export const getDataBreadcrumbs = {
  title: '',
  url: '',
  children: [
    {
      title: 'Instituciones',
      url: '',
      children: [
        {
          title: 'Lista de instituciones',
          url: '/schools',
          name: 'schools',
        },
        {
          title: 'Crear institución',
          url: '/schools',
          name: 'schoolsCreate',
        },
      ],
    },
    {
      title: 'Usuarios',
      url: '',
      children: [
        {
          title: 'Lista de usuarios',
          url: '/users',
          name: 'users',
        },
        {
          title: 'Crear usuario',
          url: '/users',
          name: 'usersCreate',
        },
      ],
    },
    {
      title: 'Académico',
      url: '',
      children: [
        {
          title: 'Lista de clases',
          url: '/classes',
          name: 'clases',
          children: [
            {
              title: 'Reportes',
              url: '',
              name: 'academicReport',
            },
            {
              title: 'Clase',
              url: '',
              name: 'classroomTBG',
            },
            {
              title: 'Clase',
              url: '',
              name: 'classroomSBG',
            },
            {
              title: 'Clase',
              url: '',
              name: 'newClassroomSBG',
            },
          ],
        },
        {
          title: 'Banco de descriptores',
          url: '/descriptors',
          name: 'descriptorBank',
        },
        {
          title: 'Banco de indicadores',
          url: '/performance',
          name: 'performanceIndicator',
        },
      ],
    },
    {
      title: 'Observador',
      url: '',
      children: [
        {
          title: 'Gestión de observaciones',
          url: '/observations/management',
          name: 'observationsManagement',
          children: [
            {
              title: 'Observador',
              url: '/observations/user/:idUser',
              name: 'observationsReport',
            },
            {
              title: 'Nueva observación',
              url: '/new-observations/:id',
              name: 'observationsCreate',
            },
            {
              title: 'Editar observación',
              url: '/observations/:idObservation/edit',
              name: 'observationsEdit',
            },
          ],
        },
        {
          title: 'Mi observador',
          url: '/observations/my-report',
          name: 'observationsMyReport',
        },
        {
          title: 'Observador del estudiante',
          url: '/observations/my-children',
          name: 'observationsMyChildren',
        },
      ],
    },
    {
      title: 'Configuración',
      url: '',
      children: [
        {
          title: 'Gestión de áreas académicas',
          url: '/settings/areas',
          name: 'settingsAreas',
        },
        {
          title: 'Gestión de ásignaturas',
          url: '/settings/subjects',
          name: 'settingsSubjects',
        },
        {
          title: 'Gestión de electivas',
          url: '/settings/electives',
          name: 'settingsElectives',
        },
        {
          title: 'Gestión de grados',
          url: '/settings/grades',
          name: 'settingsGrades',
        },
        {
          title: 'Gestión de grupos',
          url: '/settings/groups',
          name: 'settingsGroups',
          children: [
            {
              title: 'Carga académica',
              url: '',
              name: 'settingsLoadAcademic',
            },
          ],
        },
        {
          title: 'Gestión de periodos',
          url: '/settings/periods',
          name: 'settingsPeriods',
        },
        {
          title: 'Gestión de matrículas',
          url: '/settings/enrollments',
          name: 'settingsEnrollments',
        },
        {
          title: 'Gestión de años',
          url: '/settings/years',
          name: 'settingsYears',
        },
        {
          title: 'Gestión de parámetros',
          url: '/settings/params',
          name: 'settingsParams',
        },
        {
          title: 'Gestión de posts',
          url: '/cms',
          name: 'cmsManagement',
        },
      ],
    },
    {
      title: 'Perfil',
      url: '/accounts/profile',
      name: 'accountsProfile',
      children: [
        {
          title: 'Configuración',
          url: '/settings',
          name: 'settingsProfile',
        },
      ],
    },
    {
      title: 'Restaurante',
      url: '',
      children: [
        {
          title: 'Venta',
          url: '/sales',
          name: 'sales',
        },
        {
          title: 'Productos',
          url: '/sales/products',
          name: 'products',
        },
        {
          title: 'Recargas',
          url: '/sales/recharges',
          name: 'recharges',
        },
        {
          title: 'Gestión de ventas',
          url: '/sales/management',
          name: 'salesManagement',
        },
        {
          title: 'Reportes',
          url: '/sales/reports',
          name: 'reports',
        },
        {
          title: 'Mi Reporte',
          url: '/sales/my-report',
          name: 'my-report',
        },
        {
          title: 'Control parental',
          url: '/sales/parental-control',
          name: 'parentalControl',
        },
      ],
    },
    {
      title: 'Evento',
      url: '/closing/tickets',
      children: [
        {
          title: 'Evento',
          url: '/closing/tickets',
          name: 'tickets',
        },
      ],
    },
    {
      title: 'Nómina',
      url: '',
      children: [
        {
          title: 'Lista de empleados',
          url: '/employees',
          name: 'employees',
          children: [
            {
              title: 'Crear empleado',
              url: '/employee/create',
              name: 'create-employee',
            },
            {
              title: 'Editar empleado',
              url: '/employee/create',
              name: 'edit-employee',
            },
          ],
        },
        {
          title: 'Gestión de periodos',
          url: '/payrolls/periods',
          name: 'managment-periods',
          children: [
            {
              title: 'Importar Nómina',
              url: '/payrolls/import',
              name: 'import-payroll',
            },
          ],
        },
        {
          title: 'Configuración de Nómina',
          url: '/payroll/settings',
          name: 'nomina-settings',
        },
      ],
    },
    {
      title: 'Contabilidad',
      url: '',
      children: [
        {
          title: 'Cuentas contables',
          url: '/accountant/puc',
          name: 'accountant-puc',
        },
        {
          title: 'Centro de costos',
          url: '/accountant/cost-center',
          name: 'accountant-cost-center',
        },
      ],
    },
  ],
}
